<template>
  <div class="batch-setting">
    <Modal v-model="show" width="960" title="批量设置账单运营提交确认">
      <div class="modal-main">
        <RemarkCard>
          <p style="margin-bottom: 4px">
            ①运营提交确认即表示对本次账单结算金额确认无误，请根据实际情况进行审批操作。
          </p>
          <p>
            ②确定后，机构端将可见账单的结算金额，且账单中对应的课时、节次将不再支持退款、调整上课时间等
          </p>
        </RemarkCard>
        <div class="flex" style="padding-top: 16px">
          <p class="flex flexae" style="margin-right: 50px">
            已选账单数：<strong>{{ selectionRows.length }}</strong
            >个
          </p>
          <p>
            月份：<strong>{{
              selectionRows.length ? selectionRows[0]['settleMonth'] : ''
            }}</strong>
          </p>
        </div>
        <h2 style="padding: 10px 0 4px 0">机构名单:</h2>
        <div class="list">
          <ul>
            <li v-for="item in selectionRows" :key="item.statementId">
              {{ item.orgName }}
            </li>
          </ul>
        </div>
      </div>
      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import RemarkCard from '@c/Base/RemarkCard.vue'
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  components: {
    RemarkCard
  },
  data() {
    return {
      show: false,
      selectionRows: []
    }
  },
  methods: {
    handleShow(selectionRows) {
      this.show = true
      this.selectionRows = selectionRows
    },
    handleOk() {
      this.batchConfirmSettleSheet()
    },
    handleCancel() {
      this.show = false;
    },
    async batchConfirmSettleSheet() {

      let data = this.selectionRows.map(item => {
        return {
          sheetId: item.sheetId,
          totalDivideAmt: item.settleAvailAmt.replace(/,/g, '') * 100
        }
      })
      this.$Spin.show();
      let res = await orderCenterApi.batchOperationsApproval(data)
      this.$Spin.hide();
      if (res.status == 200) {
        this.show = false
        localStorage.setItem('batchSettlementTaskId', res.message)
        this.$emit('on-finish', res.message)
      }
    }
  }
}
</script>

<style  lang="scss" scoped>
.list {
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 12px;
  max-height: 500px;
  overflow-y: scroll;
  ul {
  }
}
</style>